function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import PropTypes from 'prop-types';
import FilterCollectionElementView from './filter-collection-element-view';
var FilterCollectionView = /*#__PURE__*/function (_React$Component) {
  function FilterCollectionView(props) {
    var _this;
    _classCallCheck(this, FilterCollectionView);
    _this = _callSuper(this, FilterCollectionView, [props]);
    _this.state = {
      collapsed: true
    };
    _this.handleChange = _this.handleChange.bind(_this);
    _this.toggleCollapsed = _this.toggleCollapsed.bind(_this);
    return _this;
  }
  _inherits(FilterCollectionView, _React$Component);
  return _createClass(FilterCollectionView, [{
    key: "handleChange",
    value: function handleChange(e) {
      var _this$props = this.props,
        filter = _this$props.filter,
        onChange = _this$props.onChange;
      var element = filter.elements.find(function (el) {
        return el.id === e.target.value;
      });
      onChange(element);
    }
  }, {
    key: "toggleCollapsed",
    value: function toggleCollapsed() {
      this.setState({
        collapsed: !this.state.collapsed
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        filter = _this$props2.filter,
        isDesktop = _this$props2.isDesktop;
      var collapsed = this.state.collapsed;
      return /*#__PURE__*/React.createElement("div", {
        className: "collection ".concat(collapsed ? 'collection--collapsed' : '')
      }, /*#__PURE__*/React.createElement("div", {
        className: "collection__header",
        role: "button",
        tabIndex: isDesktop ? '-1' : '0',
        onKeyPress: function onKeyPress(e) {
          return e.key === 'Enter' && _this2.toggleCollapsed;
        },
        onClick: this.toggleCollapsed
      }, /*#__PURE__*/React.createElement("h4", {
        className: "collection__header__title"
      }, filter.defaultText)), /*#__PURE__*/React.createElement("div", {
        className: "collection__list-wrapper",
        hidden: collapsed && !isDesktop
      }, /*#__PURE__*/React.createElement("ul", {
        className: "collection__list"
      }, filter.elements.map(function (element) {
        return element.name !== '' ? /*#__PURE__*/React.createElement(FilterCollectionElementView, {
          key: element.id,
          id: element.id,
          checked: element.selected,
          onChange: _this2.handleChange,
          label: element.name
        }) : null;
      }))));
    }
  }]);
}(React.Component);
FilterCollectionView.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  filter: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  isDesktop: PropTypes.bool
};
FilterCollectionView.defaultProps = {
  onChange: function onChange() {
    return null;
  },
  isDesktop: false
};
export default FilterCollectionView;